<template>
  <div>
    <!-- 搜索框和新增按钮 -->
    <el-card class="search-card">
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div style="display: flex; gap: 20px">
          <!-- 精准搜索名称搜索 -->
          <el-input
            v-model="filters.keyword"
            style="width: 240px"
            placeholder="请输入精准搜索名称"
            clearable
            @input="fetchTableData"
          />
          <!-- 任务名称搜索 -->
          <el-input
            v-model="filters.name"
            style="width: 240px"
            placeholder="请输入任务名称"
            clearable
            @input="fetchTableData"
          />
          <!-- 任务类型筛选 -->
          <el-select
            v-model="filters.task_type"
            placeholder="请选择任务类型"
            style="width: 180px"
            clearable
            @change="fetchTableData"
          >
            <el-option label="常规" value="1" />
            <el-option label="紧急" value="2" />
          </el-select>
        </div>
        <!-- 新增按钮 -->
        <el-button type="primary" @click="openAddTaskDialog">新增</el-button>
      </div>
    </el-card>

    <!-- 表格 -->
    <el-card class="search-card">
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
        "
      >
        <div>
          <el-badge
            :value="taskStatusCount[0]"
            class="item"
            style="margin-right: 30px"
          >
            <el-button @click="filterByStatus(0)">全部任务</el-button>
          </el-badge>

          <el-badge
            :value="taskStatusCount[1]"
            class="item"
            style="margin-right: 30px"
            type="warning"
          >
            <el-button @click="filterByStatus(1)">未开始</el-button>
          </el-badge>

          <el-badge
            :value="taskStatusCount[2]"
            class="item"
            style="margin-right: 30px"
            type="primary"
          >
            <el-button @click="filterByStatus(2)">进行中</el-button>
          </el-badge>

          <el-badge
            :value="taskStatusCount[3]"
            class="item item3"
            style="margin-right: 30px"
          >
            <el-button @click="filterByStatus(3)">完成</el-button>
          </el-badge>

          <el-badge
            :value="taskStatusCount[4]"
            class="item"
            style="margin-right: 30px"
          >
            <el-button @click="filterByStatus(4)">停止</el-button>
          </el-badge>
        </div>
      </div>
      <template>
        <el-table
          :data="paginatedData"
          style="width: 100%"
          :row-key="(row) => row.id"
        >
          <!-- 任务类型 -->
          <el-table-column
            prop="task_type_text"
            label="任务类型"
            :min-width="150"
          >
            <template #default="scope">
              <el-tag :type="scope.row.task_type === 1 ? 'primary' : 'danger'">
                {{ scope.row.task_type_text }}
              </el-tag>
            </template>
          </el-table-column>

          <!-- 任务名称 -->
          <el-table-column prop="name" label="任务名称" :min-width="200" />
          <el-table-column prop="bid" label="bid" :min-width="200" />
          <!-- 精准搜索名称 -->
          <el-table-column
            prop="keyword"
            label="精准搜索名称"
            :min-width="200"
          />
          <!-- 任务状态 -->
          <el-table-column
            prop="task_status_text"
            label="任务状态"
            :min-width="150"
          >
            <template #default="scope">
              <el-tag :type="getTaskStatusTagType(scope.row.task_status)">
                {{ getTaskStatusText(scope.row.task_status) }}
              </el-tag>
            </template>
          </el-table-column>

          <!-- 进度条 -->
          <el-table-column label="进度" :min-width="200">
            <template #default="scope">
              <ProgressBar
                :percentage="scope.row.progress || 0"
                :status="getProgressStatus(scope.row.progress)"
              />
            </template>
          </el-table-column>

          <!-- 操作列 -->
          <el-table-column label="操作" :min-width="250">
            <template #default="scope">
              <el-button
                v-if="[1, 2].includes(scope.row.task_status)"
                type="warning"
                @click="updateTaskStatus(scope.row, 4)"
              >
                暂停
              </el-button>
              <el-button
                v-if="scope.row.task_status === 4"
                type="danger"
                @click="updateTaskStatus(scope.row, 2)"
              >
                重启
              </el-button>
              <el-button
                type="info"
                plain
                @click="viewTaskDetail(scope.row.id)"
              >
                查看详情
              </el-button>
              <el-button type="primary" @click="editTask(scope.row)">
                编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-card>

    <!-- 分页器 -->
    <el-pagination
      :current-page="pageIndex"
      :page-size="page_size"
      :total="totalItems"
      layout="total, sizes, prev, pager, next, jumper"
      @current-change="handlePageChange"
      @size-change="handlepage_sizeChange"
    />

    <!-- 弹窗 -->
    <AddTaskDialog />
    <TaskDetailDialog />
    <EditTaskDialog @taskUpdated="fetchTableData" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AddTaskDialog from './components/AddTaskDialog'
import TaskDetailDialog from './components/TaskDetailDialog.vue'
import EditTaskDialog from './components/EditTaskDialog.vue'
import ProgressBar from './components/ProgressBar'
import { taskList, stopTask } from '@/api/miniAd'

export default {
  name: 'TaskList',
  components: {
    AddTaskDialog,
    ProgressBar,
    TaskDetailDialog,
    EditTaskDialog // 引入编辑弹窗
  },
  data() {
    return {
      filters: {
        keyword: '', // 精准搜索名称
        name: '', // 任务名称
        task_status: '', // 任务状态
        task_type: '' // 任务类型
      },
      tableData: [], // 表格数据
      totalItems: 0, // 总条目数
      pageIndex: 1, // 当前页码
      page_size: 10, // 每页大小
      taskStatusCount: {
        // 任务状态数量
        0: 0, // 全部任务
        1: 0, // 未开始
        2: 0, // 进行中
        3: 0, // 完成
        4: 0 // 停止
      }
    }
  },
  computed: {
    paginatedData() {
      return this.tableData // 接口返回分页数据，不需要额外处理
    },
    ...mapGetters('dialog', ['showAddTaskDialog'])
  },
  mounted() {
    // 将 mounted 移动到 methods 之前
    this.fetchTableData()
  },
  methods: {
    ...mapActions('dialog', [
      'openAddTaskDialog',
      'openTaskDetailDialog',
      'openEditTaskDialog'
    ]),
    async fetchTableData() {
      try {
        const params = {
          keyword: this.filters.keyword,
          name: this.filters.name,
          task_status: this.filters.task_status,
          task_type: this.filters.task_type,
          page: this.pageIndex,
          page_size: this.page_size
        }

        if (this.pageIndex === 1 && !this.filters.task_status) {
          // 首次加载时获取所有数据用于统计
          await this.fetchAllData()
        } else {
          // 否则根据当前筛选条件分页加载数据
          const response = await taskList(params)
          this.tableData = response.data.list || []
          this.totalItems = response.data.count || 0
        }
      } catch (error) {
        this.$message.error('获取表格数据失败，请稍后重试！')
      }
    },
    async fetchAllData() {
      try {
        const params = {
          keyword: this.filters.keyword,
          name: this.filters.name,
          task_status: this.filters.task_status,
          task_type: this.filters.task_type,
          page: 1, // 强制第一页
          page_size: 10 // 获取所有任务，不限制数据
        }

        const response = await taskList(params) // 获取所有任务数据
        this.tableData = response.data.list || [] // 表格数据
        this.totalItems = response.data.count || 0 // 总条目数

        // 计算任务状态数量，基于所有任务
        this.calculateTaskStatusCount()
      } catch (error) {
        this.$message.error('获取所有任务数据失败，请稍后重试！')
      }
    },

    calculateTaskStatusCount() {
      const statusCount = {
        0: this.totalItems, // 全部任务
        1: 0, // 未开始
        2: 0, // 进行中
        3: 0, // 完成
        4: 0 // 停止
      }

      this.tableData.forEach((task) => {
        statusCount[task.task_status]++
      })

      // 更新任务状态数量
      this.taskStatusCount = statusCount
    },

    handlePageChange(newPage) {
      this.pageIndex = newPage
      this.fetchTableData()
    },
    handlepage_sizeChange(newSize) {
      this.page_size = newSize
      this.fetchTableData()
    },
    getProgressStatus(progress) {
      if (typeof progress !== 'number') {
        return 'exception' // 默认返回异常状态
      }
      if (progress === 0) {
        return 'exception'
      } else if (progress >= 100) {
        return 'success'
      } else {
        return 'active'
      }
    },
    editTask(task) {
      this.openEditTaskDialog({
        id: task.id,
        name: task.name,
        page: task.page
      })
    },
    async updateTaskStatus(row, newStatus) {
      try {
        // 先获取当前状态快照
        const currentStatus = row.task_status

        // 执行异步操作
        await stopTask({ id: row.id, task_status: newStatus })

        // 更新前二次验证状态（如果业务需要）
        if (row.task_status === currentStatus) {
          this.$set(row, 'task_status', newStatus)
        }

        this.$message.success('任务状态已更新！')
        this.fetchTableData() // 建议增加数据刷新确保一致性
      } catch (error) {
        console.error('更新任务状态失败:', error)
        this.$message.error('更新任务状态失败，请稍后重试！')
      }
    },
    viewTaskDetail(id) {
      this.openTaskDetailDialog(id)
    },
    // 获取任务状态文本
    getTaskStatusText(status) {
      const statusMap = {
        1: '未开始',
        2: '进行中',
        3: '完成',
        4: '停止'
      }
      return statusMap[status] || '未知'
    },

    // 获取任务状态标签类型
    getTaskStatusTagType(status) {
      const typeMap = {
        1: 'warning', // 未开始
        2: 'primary', // 进行中
        3: 'success', // 完成
        4: 'danger' // 停止
      }
      return typeMap[status] || 'default'
    },
    // 筛选任务状态
    filterByStatus(status) {
      this.filters.task_status = status // 设置当前筛选的任务状态
      this.pageIndex = 1 // 每次筛选时从第一页开始
      this.fetchTableData() // 重新加载数据
    }
  }
}
</script>

<style scoped>
.search-card {
  margin: 20px;
}
.item3 .el-badge__content {
  background-color: green;
}
</style>
